import { OptionsClass } from "./MainApp";
import { PaginationV2 } from "./Pagination";
import { ReportListDownloadData } from "./Report";

export class SummarySTTData {
  sttNo = "";
  lastStatus = "";
  updatedAt = "";
  bookingDate = "";
  posName = "";
  posLevel = "";
  origin = "";
  destination = "";
  productType = "";
  estimationDate = "";
  isOnSLA = false;
  isCOD = false;
  isDFOD = false;
  rejectReason = "";
  dexAttemps = 0;
  delAttemps = 0;
  codRejAttemps = 0;
  courierName = "";
  lastDelivPartnerName = "";
  lastDelivAt = "";

  constructor(fields?: Partial<SummarySTTData>) {
    Object.assign(this, fields);
  }
}

export const PusatResolusiV2CodeResponseCreate = {
  101: 101,
  102: 102,
  103: 103,
  104: 104
};

export const PusatResolusiV2Status = {
  NEW: {
    label: "Baru",
    text: "text-blue-lp-300",
    background: "bg-blue-lp-200",
    border: "border-blue-lp-700"
  },
  WORKING: {
    label: "Dalam proses",
    text: "text-yellow-lp-100",
    background: "bg-yellow-lp-200",
    border: "border-yellow-lp-500"
  },
  ESCALATED: {
    label: "Dalam eskalasi",
    text: "text-purple-lp-800",
    background: "bg-purple-lp-100",
    border: "border-purple-lp-800"
  },
  "ON HOLD": {
    label: "Ditunda sementara",
    text: "text-gray-lp-300",
    background: "bg-gray-lp-200",
    border: "border-gray-lp-300"
  },
  SOLVED: {
    label: "Sudah direspon",
    text: "text-aqua-lp-500",
    background: "bg-aqua-lp-200",
    border: "border-aqua-lp-500"
  },
  CLOSED: {
    label: "Ditutup",
    text: "text-chocolate-lp-100",
    background: "bg-chocolate-lp-200",
    border: "border-chocolate-lp-400"
  },
  RESOLVED: {
    label: "Selesai",
    text: "text-green-lp-400",
    background: "bg-green-lp-300",
    border: "border-green-lp-400"
  },
  "DOCUMENT REQUIRED": {
    label: "Menunggu dokumen",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  "DOCUMENT RECEIVED": {
    label: "Dokumen diterima",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  INVESTIGATION: {
    label: "Dalam investigasi",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  INSURANCE: {
    label: "Diproses asuransi",
    text: "text-pink-lp-600",
    background: "bg-pink-lp-500",
    border: "border-pink-lp-300"
  },
  "CUSTOMER CONFIRMATION": {
    label: "Konfirmasi customer",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  PAID: {
    label: "Dibayar",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  REJECT: {
    label: "Ditolak",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  RECONCILE: {
    label: "Rekonsiliasi",
    text: "text-gray-lp-1000",
    background: "bg-gray-lp-300",
    border: "border-gray-lp-600"
  },
  DEFAULT: {
    label: "-",
    text: "text-gray-lp-300",
    background: "bg-gray-lp-200",
    border: ""
  }
};

export enum PusatResolusiV2Action {
  VIEW_DETAIL = "VIEW_DETAIL",
  CLAIM = "CLAIM",
  CS = "CS"
}

export const PusatResolusiV2Type = {
  shippingService: "PENGIRIMAN_BANTUAN",
  systemPenalty: "SISTEM_BANDING_PINALTI"
};

export class PusatResolusiV2Detail {
  type = PusatResolusiV2Type.shippingService;
  sttNoShipmentNo = "";
  category = new OptionsClass();
  description = "";
  attachments: (File | null)[] = [null];
  isDescRequired = true;
  isAttachmentRequired = true;

  constructor(fields?: Partial<PusatResolusiV2Detail>) {
    Object.assign(this, fields);
  }
}

export class TicketPusatResolusiDetail {
  id = 0;
  caseNumber = "";
  ticketNo = "";
  refNo = "";
  categoryCode = "";
  categoryName = "";
  ticketSource = "";
  desc = "";
  isEligibleCategory = false;
  shipmentId = "";
  shipmentLastStatus = "";
  sttNo = "";
  sttLastStatus = "";
  message = "";
  status = "";
  success = false;
  code = 200;
  action: PusatResolusiV2Action | "" = "";
  caseType = "";

  constructor(fields?: Partial<TicketPusatResolusiDetail>) {
    Object.assign(this, fields);
  }

  get statusData() {
    return PusatResolusiV2Status[
      this.status?.toUpperCase() as keyof typeof PusatResolusiV2Status
    ] || {...PusatResolusiV2Status['DEFAULT'], label: this.status};
  }
}

export class CategoryPusatResolusi {
  code = "";
  type = "";
  typeLabel = "";
  label = "";
  template = "";
  isEligible = false;
  isDescRequired = true;
  isAttachmentRequired = true;
  caseType = "";

  constructor(fields?: Partial<CategoryPusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class TicketCounterPusatResolusi {
  countTicketNeedToBeSolved = 0;
  countNewMessage = 0;
  countMention = 0;
  countTicketNeedToReview = 0;

  constructor(fields?: Partial<TicketCounterPusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class PusatResolusiSTTData {
  data: PusatResolusiSTT[];
  page: number;
  limit: number;
  totalRecords: number;
  isLoading: boolean;

  constructor(fields: Partial<PusatResolusiSTTData> = {}) {
    const { data = [], page = 1, limit = 20, totalRecords = 0 } = fields;
    this.data = data;
    this.page = page;
    this.limit = limit;
    this.totalRecords = totalRecords;
    this.isLoading = false;
  }
}

export class PusatResolusiSTT {
  sttNo = "";
  senderName = "";
  originCity = "";
  destinationCity = "";
  lastStatus = "";
  constructor(fields?: Partial<PusatResolusiSTT>) {
    Object.assign(this, fields);
  }
}

export class ListTicketData {
  id = 0;
  issueNo = "";
  needToBeSolved = false;
  sttOrShipmentNumber = "";
  categoryIssue = "";
  ticketPriority = "";
  statusTicket = "";
  createdAt = "";
  createdBy = "";
  unreadMessage = false;
  mentioned = false;
  eligibleAction = "";
  assignToUsername = "";
  eligibleReview = false;
  reviewType = "";
  isClaim = false;
  isExpiredReview = false;

  constructor(fields?: Partial<ListTicketData>) {
    Object.assign(this, fields);
  }

  get statusData() {
    return PusatResolusiV2Status[
      this.statusTicket?.toUpperCase() as keyof typeof PusatResolusiV2Status
    ] || {...PusatResolusiV2Status['DEFAULT'], label: this.statusTicket};
  }
}

export class ListTicketPusatResolusi {
  pagination = new PaginationV2();
  data: ListTicketData[] = [];

  constructor(fields?: Partial<ListTicketPusatResolusi>) {
    Object.assign(this, fields);
  }
}
export class CheckIssuePusatResolusi {
  id = 0;
  caseNumber = "";
  refNo = "";
  categoryCode = "";
  categoryName = "";
  isEligibleCategory = false;
  shipmentLastStatus = "";
  sttLastStatus = "";
  statusTicket = "";
  action = "";

  constructor(fields?: Partial<CheckIssuePusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class TicketListItem {
  id = 0;
  caseType = "";
  caseNumber = "";
  ticketNo = "";
  refNo = "";
  categoryCode = "";
  categoryName = "";
  isEligibleCategory = false;
  shipmentLastStatus = "";
  sttLastStatus = "";
  statusTicket = "";
  action = "";

  constructor(fields?: Partial<TicketListItem>) {
    Object.assign(this, fields);
  }
}

export class MentionsData {
  type = "";
  code = "";
  name = "";
  hubName = "";
  hubId = "0";
  constructor(fields?: Partial<MentionsData>) {
    Object.assign(this, fields);
  }
}
export class CategoryData {
  code = "";
  case = "";
  type = "";
  typeLabel = "";
  label = "";

  constructor(fields?: Partial<CategoryData>) {
    Object.assign(this, fields);
  }
}

export class AttachmentData {
  name = "";
  size = 0;
  fileName = "";
  ext = "";
  url = "";
  sizeInKB = 0;

  constructor(fields?: Partial<AttachmentData>) {
    Object.assign(this, fields);
  }
}

export class RequestFinishForumPusatResolusi {
  message = "";
  mentions: MentionsData[] = [];
  attachments: any = [];
  constructor(fields?: Partial<RequestFinishForumPusatResolusi>) {
    Object.assign(this, fields);
  }
}
export class EscalatePartnerData {
  escalateAt = "";
  escalateFinish = "";
  escalatePartnerCode = "";
  escalatePartnerName = "";
  escalatePartnerUsername = "";
  createdAt = "";
  escalateHubName = "";
  isYou = false;

  constructor(fields?: Partial<EscalatePartnerData>) {
    Object.assign(this, fields);
  }
}

export class FollowerData {
  accountPartnerCode = "";
  accountPartnerName = "";
  accountUsername = "";
  hubName = "";
  isYou = false;

  constructor(fields?: Partial<FollowerData>) {
    Object.assign(this, fields);
  }
}

export class TicketData {
  id = 0;
  refNo = "";
  ticketNo = "";
  desc = "";
  status = "";
  caseNumber = 0;
  categoryCode = "";
  category = new CategoryData();
  priority = "";
  attachments: AttachmentData[] = [];
  createdAt = "";
  createdBy = 0;
  createdByUsername = "";
  createdByPartnerCode = "";
  createdByPartnerName = "";
  createdByTier = "";
  createdByHubName = "";
  isYou = false;
  updatedAt = "";
  note = "";
  agentCsName = "";
  agentCsId = "";
  agentCsAt = "";
  agentCsFullname = "";
  escalatePartner: EscalatePartnerData[] = [];
  escalatePartnerHistory: EscalatePartnerData[] = [];
  followers: FollowerData[] = [];
  reviewType = "";
  reviewMessage = "";
  isExpiredReview = false;

  constructor(fields?: Partial<TicketData>) {
    Object.assign(this, fields);
  }
}

export class SummaryData {
  isSla = false;
  bookedAt = "";
  bookedName = "";
  bookedTier = "";
  lastStatus = "";
  lastStatusAt = "";
  originCity = "";
  destinationCity = "";
  product = "";
  estimatedSlaStartDate = "";
  estimatedSlaEndDate = "";
  isCod = false;
  isDfod = false;
  isInsurance = false;
  grossWeight = 0;
  volumeWeight = 0;
  chargeableWeight = 0;
  totalPiece = 0;
  dimLength = 0;
  dimHeight = 0;
  dimWidth = 0;
  codAmount = 0;
  goodsPrice = 0;
  totalDelAttempt = 0;
  totalDexAttempt = 0;
  totalCodrejattempt = 0;
  lastDelivStatus = "";
  lastDelivAt = "";
  lastDelivReasonCode = "";
  lastDelivReasonName = "";
  lastDelivPartnerCode = "";
  lastDelivPartnerName = "";
  lastDelivCourierName = "";
  commodityCode = "";
  commodityName = "";
  commodityIsDg = false;
  commodityIsQuarantine = false;

  constructor(fields?: Partial<SummaryData>) {
    Object.assign(this, fields);
  }
}
export class DexAssessment {
  daId = "";
  daDeliveryReasonTitle = "";
  daTicketNo = "";
  daSttId = 0;
  daSttNo = "";
  daSttProductType = "";
  daSttOriginCityId = "";
  daSttOriginCityName = "";
  daSttDestinationCityId = "";
  daSttDestinationCityName = "";
  daSttDestinationDistrictId = "";
  daSttDestinationDistrictName = "";
  daSttSenderName = "";
  daSttSenderPhone = "";
  daSttRecipientName = "";
  daSttRecipientPhone = "";
  daSttRecipientAddressType = "";
  daSttRecipientAddress = "";
  daSttSla = "";
  daDeliveryId = 0;
  daDeliveryCourierName = "";
  daDeliveryCourierPhone = "";
  daDeliveryProofPhotoDex = "";
  daDeliveryReasonCode = "";
  daDeliveryReasonCategory = "";
  daDeliveryDexDate = "";
  daDeliveryDexDateLocal = "";
  daDeliveryDexAttempt = 0;
  daDeliveryGeolocationDex = "";
  daDeliveryAddressDex = "";
  daDeliveryCaptainCourierName = "";
  daDeliveryCaptainCourierPhone = "";
  daDisputeCustomer = false;
  daSourceDex = "";
  daPhotoProofAssessment = "";
  daReasonDexAssessment = "";
  daLocationDexAssessment = "";
  daSourceDexAssessment = "";
  daRemarksL2: string | null = null;
  daRemarksPartner: string | null = null;
  daRemarksL2Dispute: string | null = null;
  daNeedToRts = false;
  daProofPhotoDisputePartner: string | null = null;
  daAssignedL1AccountId: number | null = null;
  daAssignedL1Name: string | null = null;
  daAssignedL1Date: string | null = null;
  daFinishedL1Date: string | null = null;
  daAssignedL2AccountId: number | null = null;
  daAssignedL2Name: string | null = null;
  daAssignedL2Date: string | null = null;
  daFinishedL2Date: string | null = null;
  daAssignedPartnerId: number | null = null;
  daAssignedPartnerName: string | null = null;
  daAssignedPartnerPhone: string | null = null;
  daAssignedPartnerDate: string | null = null;
  daFinishedPartnerDate: string | null = null;
  daTimeLeftPartnerDate: string | null = null;
  daAssignedL2DisputeAccountId: number | null = null;
  daAssignedL2DisputeName: string | null = null;
  daAssignedL2DisputeDate: string | null = null;
  daFinishedL2DisputeDate: string | null = null;
  daStatusDisputePartner: string | null = null;
  daStatus: string | null = null;
  daCreatedAt = "";
  daUpdatedAt = "";
  daMeta = "";
  daPhotoProofAssessBy: string | null = null;
  daReasonDexAssessBy: string | null = null;
  daLocationDexAssessBy: string | null = null;
  daSourceDexAssessBy: string | null = null;
  daStatusAssessBy: string | null = null;
  daFlag = "";

  constructor(fields?: Partial<DexAssessment>) {
    Object.assign(this, fields);
  }
}

export class TicketDetail {
  ticket = new TicketData();
  summary = new SummaryData();
  dexAssessment: DexAssessment[] = [];

  constructor(fields?: Partial<TicketDetail>) {
    Object.assign(this, fields);
  }
}

export class TicketAction {
  isOpenMultipleTab = false;
  isAssignedToOther = false;
  assignedUsername = "";
  action: string[] = [];
  hubId = 0;

  constructor(fields?: Partial<TicketAction>) {
    Object.assign(this, fields);
  }
}
export class ConversationValueAttachment {
  name = "";
  url = "";
  sizeInMegabytes = 0;
  ext = "";

  constructor(fields?: Partial<ConversationValueAttachment>) {
    Object.assign(this, fields);
  }
}

export class ConversationValueMention {
  type = "";
  code = "";
  name = "";
  hubName = "";
  hubId = 0;

  constructor(fields?: Partial<ConversationValueMention>) {
    Object.assign(this, fields);
  }
}

export class ConversationValue {
  oldAgent = "";
  newAgent = "";
  oldPriority = "";
  newPriority = "";
  status = "";
  oldCategory = "";
  newCategory = "";
  note = "";
  isSolved = false;
  message = "";
  title = "";
  escalatePartnerCode = "";
  escalatePartnerName = "";
  escalateNoteConversationId = 0;
  hubName = "";
  mentions: ConversationValueMention[] = [];
  attachments: ConversationValueAttachment[] = [];

  constructor(fields?: Partial<ConversationValue>) {
    Object.assign(this, fields);
  }
}

export class Conversation {
  id = 0;
  type = "";
  createdBy = 0;
  createdName = "";
  createdByPartnerCode = "";
  createdByPartnerName = "";
  createdAt = "";
  groupDate = "";
  time = "";
  isMentioned = false;
  assignedTo = "";
  isAssignedToOther = false;
  isOpenMultipleTab = false;
  isEscalatePartner = false;
  assignedUsername = "";
  error = "";
  action: string[] = [];
  value: ConversationValue = new ConversationValue();

  constructor(fields?: Partial<Conversation>) {
    Object.assign(this, fields);
  }
}

export class HistoryChatData {
  lastReadId = 0;
  lastReadAt = "";
  firstUnreadMessageAt = "";
  unreadCount = 0;
  conversations: Conversation[] = [];

  constructor(fields?: Partial<HistoryChatData>) {
    Object.assign(this, fields);
  }
}

export class HistoryChatResponse {
  data: HistoryChatData = new HistoryChatData();
  beforeId = 0;
  limit = 20;
  totalRecords = 0;

  constructor(fields?: Partial<HistoryChatResponse>) {
    Object.assign(this, fields);
  }
}

export class TemplateChat {
  templateMessage = "";
  position = 0;
  constructor(fields?: Partial<TemplateChat>) {
    Object.assign(this, fields);
  }
}

export class PusatResolusiFilterBase {
  category = [] as string[];
  mention = false;
  needToBeSolved = true;
  newMessage = false;
  needToReview = false;
  prioritas = [] as string[];
  search = "";
  sort = "asc";
  status = [] as string[];
  isClaim = false;
  constructor(fields?: Partial<PusatResolusiFilterBase>) {
    Object.assign(this, fields);
  }
}

export class PusatResolusiFilter extends PusatResolusiFilterBase {
  countMention = 0;
  countNeedToBeSolved = 0;
  countNewMessage = 0;
  countNeedToReview = 0;
  startDate = "";
  endDate = "";
  isClaim = false;
  constructor(fields?: Partial<PusatResolusiFilter>) {
    super(fields);
  }
}

export class PusatResolusiFilterTemp {
  ticketEscalate: PusatResolusiFilterBase = new PusatResolusiFilterBase();
  myTicket: PusatResolusiFilterBase = new PusatResolusiFilterBase();
  ticketFollowed: PusatResolusiFilterBase = new PusatResolusiFilterBase();
  constructor(fields?: Partial<PusatResolusiFilterTemp>) {
    Object.assign(this, fields);
  }
}

export class BulkDownload {
  pagination = new PaginationV2();
  data: ReportListDownloadData[] = [];

  constructor(fields?: Partial<BulkDownload>) {
    Object.assign(this, fields);
  }
}
